import { InventoryModel, ProfileModel } from '@pukka/api';

import { DiscountCreateFormSchemaType } from './discountFormSchema';

function getOutletIdsFromDiscount(
  discountDetail?: InventoryModel.Discount.GetDetail200Response,
  discount?: InventoryModel.Discount.List200ResponseInner,
) {
  return discountDetail?.outlet_ids || discount?.outlets.map((outlet) => outlet.outlet_id) || [];
}

function getAmountFromData(data: DiscountCreateFormSchemaType) {
  return data.category === 'fixedAmount' ? Number(data.amount) : null;
}

function getTypeFromData(data: DiscountCreateFormSchemaType) {
  return (data.category === 'fixedAmount' ? data.amountType : data.discountTypeCustom) || 'cash';
}

function getOutletsFromProfile(profile?: ProfileModel.Response) {
  return profile?.outlets ?? [];
}

export { getOutletIdsFromDiscount, getAmountFromData, getTypeFromData, getOutletsFromProfile };
